module.exports = __webpack_public_path__ + "img/locationIcon.8c0bff48.svg";